var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174 97.9",
    style: {
      enableBackground: "new 0 0 174 97.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.2,2.9H26.8c-3.9,0-7,3.2-7,7V88c0,3.9,3.2,7,7,7h120.4c3.9,0,7-3.2,7-7V9.9 C154.3,6.1,151.1,2.9,147.2,2.9z M54.5,56.3v-1.2c0-0.6-0.1-1.2-0.4-1.9c0-0.1-4.9-6.7-4.9-12.6c0-7.1,4.5-12.3,10.6-12.3 s10.6,5.2,10.6,12.3c0,6-4.9,12.6-5,12.7c-0.2,0.6-0.3,1.2-0.3,1.8v1.2c0,1.6,1,3.1,2.4,3.8l8,3.3c1.7,0.8,3,2.4,3.3,4.2l0.4,4.8 H40.4l0.4-4.8c0.3-1.9,1.6-3.5,3.3-4.2l8-3.3C53.5,59.4,54.5,57.9,54.5,56.3z M132.5,62.2V70H89.8v-7.8H132.5z M132.5,45.5v7.8 H89.8v-7.8L132.5,45.5L132.5,45.5z M80.6,36.6v-7.8h52v7.8L80.6,36.6L80.6,36.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberships);
export default __webpack_public_path__ + "static/media/memberships.aaaa5718eedbe8b557ed45e939c36ad4.svg";
export { ForwardRef as ReactComponent };